import React from "react";
import { Link } from "react-router-dom";

function About() {
  return (
    <div>
      <section
        className="page-title"
        style={{
          backgroundImage: "url(../images/background/bg-page-title-1.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>회사 소개</h1>
          <div className="bread-crumb-outer">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">회사 소개</li>
            </ul>
          </div>
        </div>
      </section>

      <div className="feature-style-1">
        <div className="auto-container">
            <div className="row clearfix">
                <div  className="col-lg-12 col-md-12 col-sm-12 col-xs-12 column testimonial_container">
                    <div className="content">
                        <h3 className="text-center">고객과 함께 가치를 더해가는 기업</h3><br/>
                        <ul className="text-center">
                            <li style={{fontSize:'2.3em', marginBottom: '20px'}}>Knowledge Leaders</li>
                            <li style={{fontSize: '1.1em', fontWeight: '400', marginBottom: '20px'}}>넥스모어시스템즈는 스마트시티 5대 연계서비스 개발 및 통합플랫폼 공급, 스마트팩토리 설계 및 구축
                                등 IoT기반 기술을 융합하여 디바이스 플랫폼 및 어플리케이션 등의 소프트웨어를 개발하여 공급하는 
                                'IoT 서비스 전문회사' 입니다. 소프트웨어, 정보통신공사업을 주축으로 ICT Total Solution Provider로써
                                고객의 가치창조를 통해 "사회 편익에 기여한다"는 사명감으로 사업을 추진하고 있습니다. </li>
                            <li className='about-logo1'><img src='./images/nexmore/about-1.png'alt=""/><img src='./images/nexmore/about-2.png'alt="" /><img src='./images/nexmore/about-3.png'alt=""/></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row clearfix">
                <div  className="col-lg-12 col-md-12 col-sm-12 col-xs-12 column testimonial_container">
                    <div className="content">
                        <h3 style={{fontSize: '20px'}} className="text-center">넥스모어 시스템즈는 "가치경영 + 고객만족 + 행복경영"의 최고의 정보통신 회사를 지향합니다. </h3>
                        <ul className="text-center">
                            <li >고객의 만족을 최우선으로 생각하며, 더욱 세련된 모습으로 모바일 융합서비스 및 솔루션을 제공하고자 합니다.
                            안으로는 우수한 인재를 소중하게 생각하는 인재경영, 우량한 재무구조와 부가가치 극대화를 통한 가치 경영 및 고객 만족과 즐거운 직장을 통한 행복경영으로 21세기의 IT분야 최고의 정보통신회사를 지향합니다.</li>
                            <li><img src='./images/nexmore/about-con1.png'alt=""/> </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row clearfix">
                <div className="about-title">
                    주요 인증
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 column testimonial_container certification">
                    <ul className="certification-card">
                        <li><div className="imageCard">
                            <img src='./images/nexmore/certification1.png'alt=""></img>
                            {/* <p>[벤처기업]</p> */}
                        </div></li>
                        <li><div className="imageCard">
                            <img src='./images/nexmore/certification2.jpg' alt=""></img>
                            {/* <p>[기업부실연구소]</p> */}
                        </div></li>
                        <li><div className="imageCard">
                            <img src='./images/nexmore/certification3.png'alt=""></img>
                            {/* <p>[전문연구사업자]</p> */}
                        </div></li>
                        <li><div className="imageCard">
                            <img src='./images/nexmore/certification4.png'alt=""></img>
                            {/* <p>[Main-Biz]</p> */}
                        </div></li>
                    </ul>
                    <ul className="certification-card">
                    <li><div className="imageCard">
                            <img src='./images/nexmore/certification5.png'alt=""></img>
                            {/* <p>[위치정보사업자]</p> */}
                        </div></li>
                        <li><div className="imageCard">
                            <img src='./images/nexmore/certification6.jpg' alt=""></img>
                            {/* <p>[정보통신공사업]</p> */}
                        </div></li>
                        <li><div className="imageCard">
                            <img src='./images/nexmore/certification7.jpg' alt=""></img>
                            {/* <p>[소프트웨어사업자]</p> */}
                        </div></li>
                        <li><div className="imageCard">
                            <img src='./images/nexmore/certification8.jpg' alt=""></img>
                            {/* <p>[Inno-Biz]</p> */}
                        </div></li>
                    </ul>

                </div>
            </div>
        </div>
    </div>
    </div>
  );
}

export default About;
